import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'redux-bundler-react';
import TreeView from './project-tree-view';
import ProjectTreeLeaf from './project-tree-leaf';
import DatasetInfo from './dataset-info-modal';
//import Recursion from './recursion';
import findIndex from 'lodash/findIndex';

function getClass(type){
  switch(type){
    case 'dam_study': 
      return "ds ds-damicon icon-inline";
    case "levee_study":
      return "ds ds-levee icon-inline";
    case "cwms": 
      return "ds ds-cwms icon-inline";
    case "silver_jackets":
      return "ds ds-silver-jackets icon-inline";
    case "fema":
      return "ds ds-fema icon-inline";
    case "flood_fight":
      return "ds ds-flood-fight icon-inline";
    case "simdams":
      return "fv fv-simdams icon-inline";
    default:
      return "mdi mdi-map icon-inline";
  }
}

function getTitle(type){
  switch(type){
    case 'dam_study': 
      return "NID Structure";
    case "levee_study":
      return "MMC Levee Study";
    case "cwms": 
      return "MMC CWMS Implementation";
    case "silver_jackets":
      return "Silver Jackets Project";
    case "fema":
      return "FEMA Project";
    case "flood_fight":
      return "Flood Fight Project";
    case "simdams":
      return "Structure Information";
    default:
      return "";
  }
}

class Panel extends React.Component {
  constructor(props){
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.clickZoom = this.clickZoom.bind(this);
    this.renderProjectContent= this.renderProjectContent.bind(this);
  }
  
  handleClose(){
    const { doCloseProject, library} = this.props;
    doCloseProject(library);
  }
  clickZoom(){
    const { doSetView, library} = this.props;
    const c3d = window.Cesium.Cartesian3.fromDegrees(library.LON, library.LAT, 43040.245494263276);
    doSetView({
      center: [library.LON, library.LAT],
      zoom: 11,      
      position:c3d
    });
  }

  renderProjectContent() {
    const { library, layers, idMap, dsLoadingLibrary, isLoading, loadingPanel} = this.props;
    const projectType = 'NID';

    const rootId = idMap[`root-${projectType}-${library.LIBRARY_ID}`];
    const rootNode = layers[rootId];
    let items = [];
    
    if(rootNode) {
      items = rootNode.children;
    }
    const libraryName = `${projectType}-${library.LIBRARY_ID}`;
    const loadingIdx = findIndex(dsLoadingLibrary, {library:libraryName});
    let loadingStatus = null;
    if(loadingPanel === rootId) {
      loadingStatus = isLoading;
    }else if(loadingIdx !== -1){      
      loadingStatus = dsLoadingLibrary[loadingIdx].status;
    }
    let projectContent = (<div>Loading Data</div>);
    if(loadingStatus ==='loading') {
      projectContent =(<div>Loading Data</div>);
    }
    this.setState({content:projectContent});
   
  }
  render(){
    //const { content } = this.state;
    const { library, layers, idMap, dsLoadingLibrary, isLoading, loadingPanel} = this.props;
    let projectType = 'NID';
    if(library.LIBRARY_TYPE==='simdams') {
      projectType = 'SIMDAMS'
    }

    const rootId = idMap[`root-${projectType}-${library.id}`];
    const rootNode = layers[rootId];
    let items = [];
    
    if(rootNode) {
      items = rootNode.children;
    }
    const libraryName = `${projectType}-${library.id}`;
    const loadingIdx = findIndex(dsLoadingLibrary, {library:libraryName});
    let loadingStatus = null;
    if(loadingIdx !== -1){      
      loadingStatus = dsLoadingLibrary[loadingIdx].status;
    }
    let content = null
    switch(loadingStatus) {
      case null:
        content = (<div className="loading">Loading Data</div>);
        break;
      case 'error':
          content = (<div>Error Loading Data</div>);
        break;
      case 'loading' || true:
        content = (<div className="loading">Loading Data</div>);
        break;
      case 'noSpatial':
          content = (<div>No Spatial Data</div>);
        break;
      case 'loaded':
        if(items.length >0){          
          // const openFoldersIdx = findIndex(dsOpenFolders, {library:libraryName})
          // let openFolders =[]
          // if(openFoldersIdx !== -1) {
          //   openFolders = dsOpenFolders[openFoldersIdx].openFolders
          // }
          // projectContent = (<Recursion libraryName={libraryName} subItems={items} openFolders={openFolders}/>);
          content =(<TreeView
            data={items}
            components={[ProjectTreeLeaf]}
            componentMatches={[]}
          />)
        }else{
          content = (<div>Loading Data</div>);
        }        
        break;
      default:
        break;
    }
    return (
      <div className="primary-panel-box">
        <span className="pull-right btn-group"  role="group">
          <button className="btn btn-danger btn-xs" title="Close Library" onClick={ this.handleClose }>close</button>
        </span>

        <div style={{display:'flex'}} title={`Center on ${getTitle(library.LIBRARY_TYPE)} - ${library.NAME}`}>
          <i className={getClass(library.LIBRARY_TYPE)} style={{cursor: 'pointer'}} onClick={this.clickZoom}></i>
          <label className="overflow-ellipsis control-label larger-font">{ library.NAME }</label>         
        </div>
        
        <div className="sidebar-list thin-scrollbar" style={{marginTop: '45px'}}>
          
          {content}
          <div style={{clear: 'both'}}></div>
        </div>
      </div>
    )
  }
}

export default connect(
  'doSetView',
  'selectIsLoading',
  'doCloseProject',
  'doOpenModalWindow',
  'selectLoadingPanel',
  'selectOpenProjects',
  'selectDsLoadingLibrary',
  'selectDsOpenFolders',
  'selectLayers',
  'selectIdMap',
  'selectDsStatusChange',
  Panel
);